const { CM_SYNC } = require('../constants/actionTypes');

const setSnycInfo = data => ({
    type: CM_SYNC,
    payload: data,
});

const sync = data => dispatch => {
    dispatch(setSnycInfo(data));
};

module.exports = {
    sync,
};
